import { useState, useEffect, useRef, useMemo } from 'react';

import debounce from 'lodash/debounce';

export function useDebounce(
  value,
  options = { delay: 100, onDebounceEnd: () => {} }
) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      options.onDebounceEnd(value);
    }, options.delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, options]);

  return debouncedValue;
}

// DO NOT USE -- THIS IS A WIP FOR CONSTRUCTOR WORK
// TODO: needs refinement
export const useDebounceRequest = (callback, delay = 1000) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      if (!ref.current) {
        return;
      }
      ref.current();
    };

    return debounce(func, delay);
  }, [delay]);

  return debouncedCallback;
};
